import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {Checkbox} from "primereact/checkbox";
import axios from "axios";

const CosttypeFormComponent = (props) => {

  const [formData, setFormData] = useState({
    purchase_order_default: false
  });
	const {t} = props;
  const [loading, setLoading] = useState(false);

	const apiCall = (method, url, data) => {
    return axios({
      method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const validate = (data) => {
    let errors = {};
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true);
    const payload = {
      ...data,
      purchase_order_default: !!data.purchase_order_default
    };
    const isUpdate = !!(props && props.initialValues && props.initialValues.id);
    const method = isUpdate ? 'put' : 'post';
    const url = isUpdate
      ? '/api/v2/cost-type/' + props.initialValues.id
      : '/api/v2/cost-type';
    apiCall(method, url, payload)
      .then(() => {
        window.App.toastShow('success', isUpdate ? 'Sikeres módosítás!' : 'Sikeres mentés!');
        window.App.setState({
          rerender: true,
          rerenderCosttypeList: true,
          sidebarCosttypeUpdate: false,
          sidebarCosttypeCreate: false
        });
        form.restart();
      })
      .catch(error => {
        window.App.toastShow('error', t('error') || 'Hiba történt!', error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    if (props && props.initialValues) {
      setFormData({
        purchase_order_default: false,
        ...props.initialValues,
        purchase_order_default: !!props.initialValues.purchase_order_default
      })
    }
  }, [])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit, submitting}) => (
      <form onSubmit={handleSubmit} className="">
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> {t('tabBasicData')}
              </h3>
            </div>
          </div>
        } className={""}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="acronym" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="acronym"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAcronym')}</label>
                  <span className="p-d-block">
                      <InputText id="acronym" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     acronym: e.target.value
                                   })
                                 }}
                                 value={formData.acronym}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
             <div className={"p-col-12 p-lg-10"}>
              <div className="p-fluid p-py-1 p-mt-2">
                <label className={"p-mr-2"}>
                  <Field name="purchase_order_default" render={({input}) => (
                    <Checkbox
                      inputId="purchase_order_default"
                      id="purchase_order_default"
                      checked={!!input.value}
                      onChange={(e) => {
                        input.onChange(!!e.checked);
                        setFormData({
                          ...formData,
                          purchase_order_default: !!e.checked
                        })
                      }}
                    />
                  )}/>
                  &nbsp;
                  {props.t('defaultCostTypeForMaterialPurchase')}
                </label>
              </div>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
              <Button type="submit" label={t('save')} icon="pi pi-check" loading={loading}
                      className="p-button-success"/>
            </div>
          </div>
        </Panel>
      </form>
    )}/>
  )
}
export default withTranslation('common')(CosttypeFormComponent);
